module.exports = __webpack_public_path__ + "static/media/linkedin.fd0d5546.png";